import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import NotFoundError from '@/components/NotFoundError.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'receiving',
    component: () => import(/* webpackChunkName: "receiving" */ '../pages/ReceivingPage.vue')
  },
  {
    path: '/debtors',
    name: 'debtors',
    component: () => import(/* webpackChunkName: "debtors" */ '../pages/DebtorsPage.vue')
  },
  {
    path: '/payments',
    name: 'payments',
    component: () => import(/* webpackChunkName: "payments" */ '../pages/PaymentsPage.vue')
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundError }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
